/**
 * @generated SignedSource<<7e08544646805a38c1e14d248e8c8143>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type GuildMembershipLevel = "EDITOR" | "MEMBER" | "ORGANIZER" | "%future added value";
export type GuildTypes = "GUILD" | "NETWORK" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type GuildNetworkRequestsLink_guild$data = {
  readonly myMembership: {
    readonly membershipLevel: GuildMembershipLevel;
  } | null | undefined;
  readonly pendingNetworkRequests: {
    readonly totalCount: number;
  };
  readonly slugId: string;
  readonly type: GuildTypes | null | undefined;
  readonly " $fragmentType": "GuildNetworkRequestsLink_guild";
};
export type GuildNetworkRequestsLink_guild$key = {
  readonly " $data"?: GuildNetworkRequestsLink_guild$data;
  readonly " $fragmentSpreads": FragmentRefs<"GuildNetworkRequestsLink_guild">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "GuildNetworkRequestsLink_guild",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "slugId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "type",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "GuildMembership",
      "kind": "LinkedField",
      "name": "myMembership",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "membershipLevel",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": "pendingNetworkRequests",
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": 1
        },
        {
          "kind": "Literal",
          "name": "membershipStatus",
          "value": "PENDING"
        }
      ],
      "concreteType": "GuildsConnection",
      "kind": "LinkedField",
      "name": "rankedNetworkGuilds",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "totalCount",
          "storageKey": null
        }
      ],
      "storageKey": "rankedNetworkGuilds(first:1,membershipStatus:\"PENDING\")"
    }
  ],
  "type": "Guild",
  "abstractKey": null
};

(node as any).hash = "0aacc9af3e84987ad3afe880233fcac9";

export default node;
